import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./top_recruiters.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const getSlidesToShow = (width) => {
  if (width <= 360) return 2;
  if (width <= 480) return 3;
  if (width <= 768) return 4;
  if (width <= 1024) return 6;
  return 8;
};

const TopRecruiters = () => {
  const [recruiters, setRecruiters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow(window.innerWidth));

  useEffect(() => {
    const fetchRecruiters = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${API_BASE}/api/admin/top-recruiters/public`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to load recruiters");
        setRecruiters(data.recruiters || []);
      } catch (err) {
        setError(err.message || "Failed to load recruiters");
      } finally {
        setLoading(false);
      }
    };
    fetchRecruiters();
  }, []);

  useEffect(() => {
    const handleResize = () => setSlidesToShow(getSlidesToShow(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <section className="main-section" id="recruiter">
      <h1 className="title">Our Top Recruiters</h1>
      <h2 className="subtitle">Trusted companies hiring our graduates</h2>

      {loading && <p>Loading recruiters...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && recruiters.length === 0 && <p>No recruiter logos available right now.</p>}

      <Slider key={slidesToShow} {...settings} className="recruiter-slider">
        {recruiters.map((item) => (
          <div className="logo-card" key={item.id}>
            {item.logo_path && (
              <img src={`${API_BASE}${item.logo_path}`} alt={item.company_name} />
            )}
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default TopRecruiters;
